import loadable from 'utils/loadable';

export const SignatureTemplateEditor = loadable(() => import('./index'), {
  fallback: null,
});
